/**
 * MapFilters — чекбокс-чипы слоёв объектов поверх карты + кнопка настроек
 * (redesign по макету «Главная»). Слои кроме СНП пока не подвязаны к данным:
 * состояние чипов локальное, на маркеры не влияет (появятся слои — сюда
 * заедет реальная фильтрация).
 */
import { LayoutGrid } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '../../../lib/cn';

const filters: ReadonlyArray<{ key: string; icon: LucideIcon }> = [
  { key: 'allObjects', icon: LayoutGrid },
  // { key: 'infrastructure', icon: Building2 },
  // { key: 'roads', icon: Route },
  // { key: 'projects', icon: FolderKanban },
  // { key: 'waterObjects', icon: Droplets },
  // { key: 'agriculture', icon: Wheat },
];

export const MapFilters = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState<ReadonlySet<string>>(
    new Set(['allObjects']),
  );

  const toggle = (key: string) =>
    setActive((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });

  return (
    <div
      className="pointer-events-auto flex w-full items-start justify-between gap-2"
      data-testid="map-filters"
    >
      <div className="flex flex-wrap items-center gap-2">
        {filters.map(({ key, icon: Icon }) => {
          const checked = active.has(key);
          return (
            <button
              key={key}
              type="button"
              role="checkbox"
              aria-checked={checked}
              onClick={() => toggle(key)}
              className="flex items-center gap-2 rounded-xl bg-white px-3.5 py-2 text-[12.5px] font-semibold text-text shadow-[0_1px_5px_rgba(0,0,0,0.1)] transition-colors hover:bg-surface-muted"
            >
              <span
                className={cn(
                  'size-4 shrink-0 rounded-full border-2 transition-colors',
                  checked
                    ? 'border-brand-500 bg-brand-500 shadow-[inset_0_0_0_2.5px_white]'
                    : 'border-surface-border bg-white',
                )}
              />
              {t(`mapFilters.${key}`)}
              <Icon className="size-4 text-text-muted" />
            </button>
          );
        })}
      </div>

      {/* <button
        type="button"
        aria-label={t('mapFilters.settings')}
        className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-[0_1px_5px_rgba(0,0,0,0.1)] transition-colors hover:bg-surface-muted"
      >
        <SlidersHorizontal className="size-4 text-brand-600" />
      </button> */}
    </div>
  );
};
